var AutocompleteListItemView = Backbone.View.extend({
  className: "checkout-autocomplete-list-item",
  events: {
    click: "click",
  },
  initialize: function (opts) {
    _.bindAll(this, "click", "remove");
    this.$el.text(this.model.get("description"));
    this.model.on("remove", this.remove);
  },
  click: function () {
    this.trigger("select", this.model.get("description"));
  },
});

var AutocompleteListView = Backbone.View.extend({
  className: "checkout-autocomplete-container",
  initialize: function () {
    _.bindAll(this, "autocomplete", "add", "select");
    this.$list = $('<div class="checkout-autocomplete-list"></div>');
    this.$el.append(this.$list);
    var settings = CheckoutSettings.getBasketSettings();
    this._sugg = new AddressSuggestion({
      SiteAccountID: settings.SiteAccountID,
    });

    this.autocompleteList = new AutocompleteCollection();
    this.autocompleteList.on("add", this.add);

    this.model.on("autocomplete", this.autocomplete);
  },
  autocomplete: function (value) {
    var _this = this;
    if (value && value.length > 3 && this.currentValue !== value) {
      this._sugg.getSuggestion(value).done(function (data) {
        data && _this.autocompleteList.update(data.predictions);
      });
    }
    if (!value || value.length <= 3) {
      this.autocompleteList.update([]);
    }
    this.currentValue = value;
  },
  add: function (model) {
    var listItem = new AutocompleteListItemView({ model: model });
    this.$list.append(listItem.$el);
    listItem.on("select", this.select);
  },
  select: function (value) {
    var _this = this;
    this._sugg.getAddress(value).done(function (data) {
      _this.model.collection.each(function (model) {
        var key = model.get("Name");
        var value = data[key];
        value && model.set("Value", value);
      });
    });
    this.autocompleteList.update([]);
  },
});

var FieldView = (function (BaseView) {
  return BaseView.extend({
    //tbd: refactor this class
    events: {
      "change select": "change",
      "keyup input": "change",
      "change input": "change",
      "input textarea": "change",
      "mouseup input": "clearedByCross",
      "input input[name='Forename']": "handleRecipientNameChange",
      "input input[name='Surname']": "handleRecipientNameChange",
    },
    initialize: function () {
      var settings = CheckoutSettings.getBasketSettings();
      this.listenTo(this.model, "change:isValid", _.bind(this._isValid, this));
      this.listenTo(
        this.model,
        "change:Value",
        _.bind(this._updateValue, this)
      );
      this.listenTo(this.model, "change:hidden", _.bind(this._hidden, this));
      this.listenTo(this.model, "remove", _.bind(this.remove, this));
      this.listenTo(
        this.model,
        "pcaUpdateModel",
        _.bind(this._updateModel, this)
      );

      this.$el = $.tmpl("bt-checkout-delivery-field", this.model.toJSON());
      this.$field = this.$("input, select");

      this.$field.keyFilter(
        this.model.get("MaxLength"),
        this.model.get("Regexp")
      );

      // Input validations
      this.minLength = this.model.get("MinLength");
      this.inputLabel = this.model.get("Label");

      InitTooltip(this.$("@info"), this.model.get("InfoTemplateName"));

      if (
        this.model.get("Name") === "AddressLines" &&
        settings.GoogleAddressSuggestionEnabled
      ) {
        var autocomplete = new AutocompleteListView({ model: this.model });
        this.$el.append(autocomplete.$el);
        if (window.app && app.event && app.event.addressFieldFocus) {
          this.$field.on("focus", app.event.addressFieldFocus);
        }
      }
    },
    handleRecipientNameChange: function (e) {
      this.change(e);

      // Check if input field is for the Gift form
      if (this.inputLabel.includes("Gift")) {
        if (
          e.target.value.length < this.minLength ||
          e.target.value.trim() !== e.target.value
        ) {
          if (e.target.name === "Forename") {
            $(".page-block-form__gift #ForenameValidation").text(
              "Please provide a name with 2 or more characters, using letters only."
            );

            $(".page-block-form__gift #ForenameValidation").addClass(
              "recipient-name-validation-error-gift"
            );
          } else {
            $(".page-block-form__gift #SurnameValidation").text(
              "Please provide a name with 2 or more characters, using letters only."
            );

            $(".page-block-form__gift #SurnameValidation").addClass(
              "recipient-name-validation-error-gift"
            );
          }
        } else if (
          $(".page-block-form__gift #Forename").val().trim().toLowerCase() ===
            $(".page-block-form__gift #Surname").val().trim().toLowerCase() &&
          $(".page-block-form__gift #Forename").val().length > 0 &&
          $(".page-block-form__gift #Surname").val().length > 0
        ) {
          $(".page-block-form__gift #ForenameValidation").text(
            "First and last name cannot be the same. Please enter different names."
          );
          $(".page-block-form__gift #SurnameValidation").text(
            "First and last name cannot be the same. Please enter different names."
          );

          $(".page-block-form__gift #Forename").addClass("errorField");
          $(".page-block-form__gift #Surname").addClass("errorField");
        } else {
          $(".page-block-form__gift #Forename").removeClass("errorField");
          $(".page-block-form__gift #Surname").removeClass("errorField");

          $(".page-block-form__gift #ForenameValidation").text("");
          $(".page-block-form__gift #SurnameValidation").text("");
        }

        // Reset error element if name is not the same
        if (
          $(".page-block-form__gift #Forename").val().trim().toLowerCase() !==
          $(".page-block-form__gift #Surname").val().trim().toLowerCase()
        ) {
          if (
            $(".page-block-form__gift #ForenameValidation").text() ===
            "First and last name cannot be the same. Please enter different names."
          ) {
            $(".page-block-form__gift #Forename").removeClass("errorField");
            $(".page-block-form__gift #ForenameValidation").text("");
          }

          if (
            $(".page-block-form__gift #SurnameValidation").text() ===
            "First and last name cannot be the same. Please enter different names."
          ) {
            $(".page-block-form__gift #Surname").removeClass("errorField");
            $(".page-block-form__gift #SurnameValidation").text("");
          }
        }
      } else {
        if (
          e.target.value.length < this.minLength ||
          e.target.value.trim() !== e.target.value
        ) {
          if (e.target.name === "Forename") {
            $("#ForenameValidation").text(
              "Please provide a name with 2 or more characters, using letters only."
            );
          } else {
            $("#SurnameValidation").text(
              "Please provide a name with 2 or more characters, using letters only."
            );
          }
        } else if (
          $("#Forename").val().trim().toLowerCase() ===
            $("#Surname").val().trim().toLowerCase() &&
          $("#Forename").val().length > 0 &&
          $("#Surname").val().length > 0
        ) {
          $("#ForenameValidation").text(
            "First and last name cannot be the same. Please enter different names."
          );
          $("#SurnameValidation").text(
            "First and last name cannot be the same. Please enter different names."
          );

          $("#Forename").addClass("errorField");
          $("#Surname").addClass("errorField");
        } else {
          $("#Forename").removeClass("errorField");
          $("#Surname").removeClass("errorField");

          $("#ForenameValidation").text("");
          $("#SurnameValidation").text("");
        }

        // Reset error element if name is not the same
        if (
          $("#Forename").val().trim().toLowerCase() !==
          $("#Surname").val().trim().toLowerCase()
        ) {
          if (
            $("#ForenameValidation").text() ===
            "First and last name cannot be the same. Please enter different names."
          ) {
            $("#Forename").removeClass("errorField");
            $("#ForenameValidation").text("");
          }

          if (
            $("#SurnameValidation").text() ===
            "First and last name cannot be the same. Please enter different names."
          ) {
            $("#Surname").removeClass("errorField");
            $("#SurnameValidation").text("");
          }
        }
      }
    },
    clearedByCross: function (e) {
      var _this = this;
      if (e.currentTarget.value === "") return;
      setTimeout(function () {
        if (e.currentTarget.value === "") _this.change(e);
      }, 0);
    },
    change: function (e) {
      this.setValue(e.currentTarget.value);
      this.model.trigger("autocomplete", e.currentTarget.value);
    },
    _isValid: function () {
      var isValid = this.model.get("isValid");
      if (isValid == null || isValid) {
        this.$field.removeClass("page-block-deliveryaddress__input__error");
      } else {
        this.$field.addClass("page-block-deliveryaddress__input__error");
      }
    },
    _updateValue: function (m) {
      if (m.hasChanged("Value")) {
        this.$field.val(this.model.get("Value"));
      }
    },
    _updateModel: function () {
      var value = this.$field.val();
      value && this.setValue(value);
    },
    _hidden: function () {
      this.$el.toggleClass("hidden-block", this.model.getHidden());
    },
    focus: function () {
      this.$field.focus();
    },
    setValue: function (value) {
      this.model.setValue(value, { silent: true });
      this.model.setChangedByUser();
    },
  });
})(BaseView);
